// src/components/layouts/Navbar.tsx
import { Link, useLocation } from 'react-router-dom'
import { useState } from 'react'
// import { useWalletContext } from '../contexts/WalletContext'
import { Logo } from '@/components/elements';
import { BodyMedium } from '@/components/typography';
// Icons:
import Wallet from '@/assets/img/icon/dashboard/Wallet.svg';
import Profile from '@/assets/img/icon/dashboard/ProfileNav.svg';
import Notifications from '@/assets/img/icon/dashboard/Notifications.svg';
import TwitterLogo from '@/assets/img/icon/22x24/x-com.svg';
import RedditLogo from '@/assets/img/icon/22x24/reddit.svg';
import TelegramLogo from '@/assets/img/icon/22x24/telegram.svg';
import DiscordLogo from '@/assets/img/icon/22x24/discord.svg';
import hamburgerIcon from '@/assets/img/icon/22x24/hamburger.svg';
import CloseIcon from '@/assets/img/icon/22x24/x-close.svg';

export const Navbar = () => {
    // const { walletAddress, isConnecting, isSessionValid, connect } = useWalletContext()
    // Remove outside of static demo
    const walletAddress = 0
    // Leave as is...
    const location = useLocation()
    const [notificationCount] = useState(3) // TODO: Connect to notification system
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    
    const isDashboard = location.pathname.includes('/dashboard');

    // const connectWallet = async () => {
    //     try {
    //         await connect()
    //     } catch (error) {
    //         console.error('Error connecting wallet:', error)
    //         alert('Failed to connect wallet. Please try again.')
    //     }
    // }

    const navItems = [
        { label: 'About', path: '/about' },
        { label: 'ICO', path: '/ico' },
        { label: 'Features', path: '/features' },
        { label: 'Marketplace', path: '/marketplace' },
        { label: 'Transparency', path: '/transparency' },
        { label: 'Support', path: '/support' },
    ]

    // Format wallet address for display
    const formatAddress = (address: string) => {
        if (!address) return '';
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    }

    return (
        <div className={`w-full ${isDashboard ? 'pt-0' : 'pt-0 lg:pt-4'} ${isDashboard ? 'fixed' : 'lg:fixed'} z-50 pointer-events-none`}>
            <div className={`w-full ${isDashboard ? 'h-20 px-[51px]' : 'lg:w-[1200px]'} relative mx-auto p-4 ${isDashboard ? 'bg-white/5 backdrop-blur-md' : 'lg:bg-white/5 lg:rounded-2xl lg:backdrop-blur-md'} flex flex-nowrap justify-between items-center pointer-events-auto`}>
                
                <div className='lg:hidden flex flex-nowrap gap-4 items-center'>
                    <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                        <img src={hamburgerIcon} alt="Open mobile menu" />
                    </button>
                    
                    <Link to="/">
                        <Logo />
                    </Link>
                </div>
                
                <Link to="/" className='hidden lg:block' >
                    <Logo />
                </Link>

                {/* Public nav - only show when NOT in dashboard */}
                {!isDashboard && (
                    <nav className="hidden lg:inline-flex justify-start items-center gap-8">
                        {navItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`justify-start text-base font-normal leading-6 hover:text-white cursor-pointer transition-colors ${
                                    location.pathname === item.path ? 'text-primary' : 'text-white/60'
                                }`}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </nav>
                )}

                {/* Dashboard nav - only show when IN dashboard */}
                {isDashboard && walletAddress && (
                    <div className="flex justify-start items-center gap-4">
                        {/* Network Selector */}
                        {/* Let's not */}
                        <button className="h-10 px-4 bg-primary rounded-2xl flex items-center gap-2">
                            <BodyMedium className="text-gray-900">
                                Solana
                            </BodyMedium>
                            <div className="w-6 h-6 relative rotate-180">
                                <div className="w-3.5 h-1.5 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-gray-900" />
                            </div>
                        </button>

                        <button className="h-10 px-4 bg-primary rounded-2xl flex items-center">
                            <BodyMedium className="text-gray-900">
                                Buy CCRAP
                            </BodyMedium>
                        </button>


                        {/* Wallet Address */}
                        <div className="hidden lg:flex items-center gap-3">
                            <div className="w-6 h-6 flex justify-center items-center">
                                <img src={Profile} alt="Profile nav icon" className="w-4 h-4" />
                            </div>
                            <BodyMedium className="text-white/60">
                                {formatAddress(walletAddress)}
                            </BodyMedium>
                        </div>

                        {/* Total Value */}
                        <div className="hidden lg:flex items-center gap-3">
                            <div className="w-6 h-6 relative flex justify-center items-center">
                                <img src={Wallet} alt="Wallet nav icon" className="w-4 h-4" />
                            </div>
                            <BodyMedium className="text-white/60">
                                $24,567.89
                            </BodyMedium>
                        </div>

                        {/* Notifications */}
                        <button className="w-7 h-8 relative">
                            <div className="w-6 h-6 relative flex justify-center items-center">
                                <img src={Notifications} alt="Notifications nav icon" className="w-5 h-5" />
                            </div>
                            {notificationCount > 0 && (
                                <div className="w-5 h-5 absolute right-0 top-0 bg-primary rounded-full flex items-center justify-center">
                                    <span className="text-gray-900 text-xs font-normal">
                                        {notificationCount}
                                    </span>
                                </div>
                            )}
                        </button>
                    </div>
                )}

                {/* Social media links / icons (static demo) */}

                <div className='flex flex-nowrap gap-4'>
                    <a href='https://www.x.com/CryptoCCRAP' target="__blank" className='h-5'>
                        <img src={TwitterLogo} alt="Twitter / X.com logo and link address" className='h-full' />
                    </a>
                    <a href='https://www.reddit.com/user/CryptoCCRAP' target="__blank" className='h-5'>
                        <img src={RedditLogo} alt="Telegram logo and link address" className='h-full' />
                    </a>

                    {/* <a href='' target="__blank" className='h-5'>
                        <img src={TelegramLogo} alt="Telegram logo and link address" className='h-full' />
                    </a>
                    <a href='' target="__blank" className='h-5'>
                        <img src={DiscordLogo} alt="Doiscord logo and link address" className='h-full' />
                    </a> */}
                </div>

                {/* Connect wallet button - only show when NOT in dashboard and not connected */}
                {/* {!isDashboard && (
                    <>
                        {walletAddress && isSessionValid ? (
                            <div className="flex items-center gap-3">
                                <Link 
                                    to="/dashboard"
                                    className="btn btn-primary btn-sm transition ease-in-out duration-200"
                                >
                                    <div className="text-base font-medium">Dashboard</div>
                                </Link>
                            </div>
                        ) : (
                            <button 
                                onClick={connectWallet}
                                disabled={isConnecting}
                                className="btn btn-primary btn-sm transition ease-in-out duration-200 disabled:opacity-50"
                            >
                                <div className="text-base font-medium">
                                    {isConnecting ? 'Connecting...' : 'Connect wallet'}
                                </div>
                            </button>
                        )}
                    </>
                )} */}
            </div>
            
            {/* Mobile Menu Overlay */}
            {isMobileMenuOpen && !isDashboard && (
                <div className="lg:hidden fixed inset-0 bg-black/90 backdrop-blur-md z-40 pointer-events-auto flex flex-col justify-center items-end gap-16">
                    <div className="w-full flex justify-end pr-6">
                        <button
                            onClick={() => setIsMobileMenuOpen(false)}
                            className="w-6 h-6"
                            aria-label="Close newsletter"
                        >
                            <img src={CloseIcon} alt="Close" className="w-[16px] h-[16px]" />
                        </button>
                    </div>

                    <nav className="flex flex-col w-full justify-center items-center gap-11">
                        <Link
                            key='Homepage'
                            to='/'
                            onClick={() => setIsMobileMenuOpen(false)}
                            className={`text-xl font-normal leading-6 ${
                                location.pathname === '/' ? 'text-primary' : 'text-white/60'
                            }`}
                        >
                            Homepage
                        </Link>
                        
                        {navItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                onClick={() => setIsMobileMenuOpen(false)}
                                className={`text-xl font-normal leading-6 ${
                                    location.pathname === item.path ? 'text-primary' : 'text-white/60'
                                }`}
                            >
                                {item.label}
                            </Link>
                        ))}
                    </nav>

                    <div className="mt-16 w-full flex justify-center items-center gap-8">
                        <a href="" target="_blank" className="w-6 h-6">
                            <img src={TwitterLogo} alt="Twitter / X.com" className="w-full h-full" />
                        </a>
                        <a href="" target="_blank" className="w-6 h-6">
                            <img src={TelegramLogo} alt="Telegram" className="w-full h-full" />
                        </a>
                        <a href="" target="_blank" className="w-6 h-6">
                            <img src={DiscordLogo} alt="Discord" className="w-full h-full" />
                        </a>
                    </div>
                </div>
            )}
        </div>
    )
}